export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCgAi5YLOQS7-tV6hsCFKNL7y4zL0YZ6c0",
    authDomain: "trayecto-ec.firebaseapp.com",
    databaseURL: "https://trayecto-ec.firebaseio.com",
    projectId: "trayecto-ec",
    storageBucket: "trayecto-ec.appspot.com",
    messagingSenderId: "871136001931",
    appId: "1:871136001931:web:b80e14b5b741cf0798798e",
    measurementId: "G-EGKGYNS5SD"
  },
  nodoAmbiente:"produccionV2"
 
};
